var map = {
	"./bg.png": 6253,
	"./cz.png": 6903,
	"./de.png": 5593,
	"./en.png": 2929,
	"./es.png": 7524,
	"./et.png": 3163,
	"./fr.png": 7020,
	"./hu.png": 9005,
	"./it.png": 1839,
	"./kz.png": 655,
	"./lt.png": 7832,
	"./lv.png": 1530,
	"./mo.png": 6032,
	"./pl.png": 8724,
	"./ro.png": 3301,
	"./ru.png": 4527,
	"./sk.png": 5678,
	"./sr.png": 3743,
	"./tk.png": 6743,
	"./ua.png": 1478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5163;